/*
 * Created on Sun Jul 11 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 * Note:
 * - Grid layout is 5 by 2 for itch article and each article-space
 * - !! video can't be viewed in development. Uncomment iframe tag to view 
 */

import { Navigation } from '../Header';
import React, { useEffect, useState, useRef, useReducer, forwardRef, useImperativeHandle, useCallback } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Footer } from '../Footer';
import { Controller, Scene } from 'react-scrollmagic';
import { Tween, Timeline } from 'react-gsap';
import { CloseButton, ConditionalWrapper } from '../components';
import { useWindowDimensions, useUserStatus, useArtworkArticleStatus, ScrollToArticle, WaitForClose } from '../utils/helpers';
import parse from 'html-react-parser';
import Modal from 'react-bootstrap/Modal';
import ReactPlayer from "react-player"
import Emitter from '../utils/emitter';
import { format } from 'date-fns'

// icons
import Trending from "../assets/images/icons/trending.png";
import { IoLocationSharp } from 'react-icons/io5';
/*
import PinkLogo from "../assets/images/icons/pink-logo-with-word.svg";
import WhiteLogo from "../assets/images/icons/white-logo-with-word.svg";
import BlackLogo from "../assets/images/icons/black-logo-with-word.svg";
*/

import PinkLogo from "../assets/images/icons/itch_white.svg";
import WhiteLogo from "../assets/images/icons/itch.svg";
import BlackLogo from "../assets/images/icons/itch_white.svg";

import BlackClose from "../assets/images/icons/black-close-feature.png";
import WhiteClose from "../assets/images/icons/white-close-feature.png";
import GreyClose from "../assets/images/icons/grey-close-feature.png";
import BlackExpand from "../assets/images/icons/black-expand-feature.png";
import WhiteExpand from "../assets/images/icons/white-expand-feature.png";
import GreyExpand from "../assets/images/icons/grey-expand-feature.png";
import { JoinUsModal } from './user';

import Comment from 'components/comment/comment';

import useGetCurrentFeaturedArtwork from 'hooks/get-featured-artwork.hook';
import useGetLatestItchArticle from 'hooks/get-itch-article.hook';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';

import { 
    MediaType, 
    AccountTypes, 
    getProfessionsText,
    AccountTypesName,
    CompanyTypesName,
    getAccountTypeMeta
} from '../constants'
import { 
    getName,
    imageUrl,
    ensureLinks,
    getImageByWidth,
    forceLinksBlankTarget
} from '../utils/utils'

import UserAvatar from 'components/avatar/user-avatar';

import countries from 'i18n-iso-countries';

import { chunk } from '../utils/helpers'

import useGetArchivedFeaturedArtworks from 'hooks/get-featured-artwork-chapters.hook'
import ProgressLoader from 'components/shared/progress-loader/progress-loader';
import Mention from 'components/zine/trending-users-articles/user'
import ItchArticleCover from 'components/zine/itch-article-cover'
import Grid from 'components/zine/trending-users-articles/grid'
import ZineFooter from 'components/zine/zine-footer';
import ZineProvider from 'components/zine/zine.context';
import { useTopNavTheme } from 'components/shared/top-nav/top-nav-theme-context'
import Share from 'components/shared/share';
import Facebook from "components/social-share/facebook";
import Twitter from "components/social-share/twitter";
import Pinterest from "components/social-share/pinterest";
import CopyLink from "components/social-share/copy-link";
import CloseFeatureButton from 'components/zine/close-feature-button';
import ExpandFeatureButton from 'components/zine/expand-feature-button';

import {
    AuthorSection,
    AuthorInfoArticleDate,
    AuthorLink,
    AuthorCategories,
    Sharing
} from 'components/articles/article.styles'
import AccountTypeCategories from 'components/shared/account-type-categories'
import SignUpWidget from 'components/shared/sign-up-widget/sign-up-widget'
import useAuth from 'hooks/auth.hook'
import { useFeaturedArtworkTheme } from 'components/zine/featured-artwork.context'
import useModal from 'hooks/modal.hook'
import { ButtonToPastItchArticles, ButtonBottomToPastItchArticles } from 'components/articles/article.styles'
import {
    icons
} from '../constants'
import { Block } from '@material-ui/icons';

countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

const pinkText = 'pink-text';
const blackText = 'black-text';
const whiteText = 'white-text';

const featuredTextColor = {
    'pink': {
        class: 'pink-tint',
        logo: PinkLogo,
        chapter: whiteText,
        year: blackText,
        author: whiteText,
        occupation: blackText,
        socialMedia: whiteText,
        title: blackText,
        text: whiteText,
        closeIcon: WhiteClose,
        expandIcon: WhiteExpand,
        mouseover: {
            author: blackText,
            socialMedia: blackText
        }
    },
    'dark': {
        class: 'black-tint',
        logo: BlackLogo,
        chapter: whiteText,
        year: pinkText,
        author: whiteText,
        occupation: pinkText,
        socialMedia: pinkText,
        title: pinkText,
        text: whiteText,
        closeIcon: GreyClose,
        expandIcon: GreyExpand,
        mouseover: {
            author: whiteText,
            socialMedia: whiteText
        }
    },
    'white': {
        class: 'white-tint',
        logo: WhiteLogo,
        chapter: pinkText,
        year: blackText,
        author: pinkText,
        occupation: blackText,
        socialMedia: blackText,
        title: pinkText,
        text: blackText,
        closeIcon: BlackClose,
        expandIcon: BlackExpand,
        mouseover: {
            author: blackText,
            socialMedia: pinkText
        }
    }
}

const itchArticleTextColor = {
    'pink': {
        class: 'pink-tint',
        type: whiteText,
        title: whiteText,
        description: whiteText,
        closeIcon: WhiteClose
    },
    'dark': {
        class: 'black-tint',
        type: pinkText,
        title: whiteText,
        description: whiteText,
        closeIcon: GreyClose
    },
    'white': {
        class: 'white-tint',
        type: pinkText,
        title: pinkText,
        description: pinkText,
        closeIcon: BlackClose
    }
}

export const userArticleTextColor = {
    'pink': {
        class: 'pink-tint',
        title: whiteText,
        description: whiteText
    },
    'dark': {
        class: 'black-tint',
        title: whiteText,
        description: whiteText
    },
    'white': {
        class: 'white-tint',
        title: pinkText,
        description: blackText
    }
}

const getOccupation = (user) => {
    let occupation = AccountTypesName[user.accountType]
    if (user.accountType === AccountTypes.FashionCompany) {
        occupation = occupation + ' / ' + CompanyTypesName[user.companyType]
    } else {
        occupation = occupation + ' / ' + getProfessionsText(user)
    }
    return occupation
}

const getAccountTypeAbbr = (accountType) => {
    if (accountType === AccountTypes.FashionArtist)
        return 'fa'
    else if (accountType === AccountTypes.FashionCompany)
        return 'fc'
    else if (accountType === AccountTypes.FashionLover)
        return 'fl'
    else return ''
}

export default function Zine() {
    const { modal } = useModal()
    const { chapter } = useParams()
    const { success: getFeatureArtworkSuccess, featuredArtwork } = useGetCurrentFeaturedArtwork(chapter)

    const { 
        success: getLatestItchArticleSuccess, 
        itchArticle
    } = useGetLatestItchArticle()
    
    document.body.style.background = 'black';
    document.body.style.overscrollBehavior = 'none'; // disable pulldown refresh

    // const adSpaceHeight = !isMobile ? 300 : 120;
    // const [shownItemCount, setShownItemCount] = useState(showCount);
    // const [items, setItems] = useState(articles.slice(1, showCount + 1));
    // const [featuredOpen, setFeaturedOpen] = useState(false);
    
    const homeRef = useRef();
    const navRef = useRef();
    const archiveModalRef = useRef();

    // const { windowWidth } = useWindowDimensions();
    
    // const tint = getFeatureArtworkSuccess ? (featuredArtwork.colourTheme ?? 'pink') : 'pink'

    // make sure user start from top
    const handleBeforeUnload = () => document.documentElement.scrollTo(0, 0);
    const checkScrollPosition = () => navRef.current && navRef.current.checkScrollPosition();
    const changeNav = () => navRef.current && navRef.current.changeNav();

    useEffect(() => {
        // make sure user always begin from top upon every refresh
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (modal?.name === 'zine-archives') {
            archiveModalRef.current.triggerModal()
        }
    }, [modal])

    return (
        <ZineProvider>
            <div className="position-relative">
                <div id="home" ref={homeRef}>
                    {getFeatureArtworkSuccess && featuredArtwork ? 
                        <FeaturedArtwork 
                            featuredArtwork={featuredArtwork} 
                            passCheckScrollPosition={checkScrollPosition} passChangeNav={changeNav} 
                        /> : null}

                    {getLatestItchArticleSuccess && itchArticle._id ? <ItchArticle itchArticle={itchArticle} /> : null}

                    <Grid />

                    {getFeatureArtworkSuccess && getLatestItchArticleSuccess ? 
                        <ZineFooter onViewArchive={() => archiveModalRef.current.triggerModal()} /> 
                    : null}
                </div>

                <ArchiveModal ref={archiveModalRef} />
                {false  && getFeatureArtworkSuccess && getLatestItchArticleSuccess ? 
                    <LogoAnimation handleClickArchive={() => archiveModalRef.current.triggerModal()} /> 
                : null}
            </div>
        </ZineProvider>
    )
}

export function ArtworkAuthorDetails({ user, author, authorStates, occupation, occupationState, location }) {
    const [hoveredAuthor, setHoveredAuthor] = useState(false);
    const { windowWidth, isMobile } = useWindowDimensions();
    return (
        <div className={"author-details text-center " + (windowWidth > 1030 ? "middle-y" : "middle-x")}>
            <a href={`/${user.itchUrl}`} className="d-inline-block" 
                style={{
                borderRadius: '50%',
                overflow: 'hidden',
                width: isMobile ? '48px' : '72px',
                height: isMobile ? '48px' : '72px'
            }}>
                <UserAvatar {...user} url={imageUrl(user.profileImage)} profileUrl={`/${user.itchUrl}`} />
            </a>
            <div className="body-text">
                <div
                    className={(hoveredAuthor ? authorStates.hovered : authorStates.normal) + " author nexa-x-bold"}
                    onMouseOver={() => setHoveredAuthor(true)}
                    onMouseOut={() => setHoveredAuthor(false)}
                >
                    <a href={`/${user.itchUrl}`}>{author.length > 25 ? author.substring(0, 25) + '...' : author}</a>
                </div>
                <div className={occupationState + " occupation"}>{occupation}</div>
                <LocationIconWrapper textColor={occupationState} location={location} />
            </div>
        </div>
    )
}

export function LocationIconWrapper({ textColor, location }) {
    return (
        <div className={textColor + " location-wrapper d-inline-flex align-items-center"}>
            <IoLocationSharp className="location-icon d-inline" />
            {/* <img src={Location} className="location-icon d-inline" alt="location icon" /> */}
            <div className="location d-inline">{location}</div>
        </div>
    )
}

export function FeaturedArtwork({ 
    featuredArtwork, 
    passCheckScrollPosition, passChangeNav 
}) {

    const [initialHeight, setInitialHeight] = useState(0);
    const [featuredArtworkSize, setFeaturedArtworkSize] = useState(window.innerHeight)
    const [open, setOpen] = useState(false);
    const [hasScroll, setScroll] = useState(false);

    const featuredRef = useRef();
    const coverRef = useRef();
    const scrollableRef = useRef();
    const scrollableInnerRef = useRef();
    const expandImageRef = useRef();
    const topNavTheme = useTopNavTheme()

    const { windowWidth, windowHeight, isMobile } = useWindowDimensions();
    const { artworkAllowed } = useArtworkArticleStatus();
    const { fetching, session } = useAuth()

    const { 
        setTheme, 
        open: expandArtwork, 
        close: minimiseArtwork,  
    } = useFeaturedArtworkTheme()

    let currentYear = new Date().getFullYear();
    let f = featuredTextColor[featuredArtwork.colourTheme];

    const openArtwork = () => {
        if (!open) {
            console.log('emit open artwork');
            Emitter.emit('openArtwork');
            expandArtwork()
        }
    }

    const waitForScroll = async () => {
        if (!open) {
            // scroll to position
            console.log('scrolling to artwork');
            const finishScrolling = await ScrollToArticle(featuredRef);
            // check if scroll is finished
            setFeaturedArtworkSize(coverRef.current.clientHeight)
            if (finishScrolling) {
                console.log('artwork is opened')
                setOpen(true);
                passChangeNav();
                if (!fetching && !session) {
                    topNavTheme.setPublicMenuFlip(true)
                    topNavTheme.setTheme('light')
                }
                Emitter.emit('artworkIsOpened');
            }
        }
    }

    const closeArtwork = async (closeWithinArtwork) => {
        if (open) {
            
            // restart text scroll when closed
            scrollableRef.current.scrollTop = 0;
            setOpen(false);
            minimiseArtwork()
            setFeaturedArtworkSize(window.innerHeight)
            
            // re-adjust window scroll position 
            const topNavElem = document.getElementById('top-nav')
            document.documentElement.scrollTop -= featuredRef.current.clientHeight - window.innerHeight - (topNavElem?.clientHeight ?? 0);
            setTimeout(async () => {
                passCheckScrollPosition();

                
                console.log('waiting to close featured');
                // wait until finish closing
                /*
                const finishClosing = await WaitForClose(window.innerHeight, featuredRef);
                // if artwork is closed by opening of article
                if (finishClosing) {
                    console.log('emit artwork is closed');
                    Emitter.emit('artworkIsClosed');
                    if (!fetching && !session) {
                        topNavTheme.setPublicMenuFlip(false)
                        topNavTheme.setTheme(featuredArtwork.colourTheme === 'white' ? 'dark' : 'light')
                    }
                    if (closeWithinArtwork) Emitter.emit('closeWithin');
                }
                */
                
                Emitter.emit('artworkIsClosed');
                if (!fetching && !session) {
                    topNavTheme.setPublicMenuFlip(false)
                    topNavTheme.setTheme(featuredArtwork.colourTheme === 'white' ? 'dark' : 'light')
                }
                if (closeWithinArtwork) Emitter.emit('closeWithin');
                
            }, 500)
        }
    }

    const triggerExpandModal = () => expandImageRef.current.triggerModal();

    useEffect(() => {
        // scroll when allowed, close when disallowed
        if (artworkAllowed) waitForScroll();
        else closeArtwork();
        // eslint-disable-next-line
    }, [artworkAllowed])

    useEffect(() => {
        window.addEventListener('scroll', setStickyButtons)
        
        setStickyButtons()
    
        return () => {
            window.removeEventListener('scroll', setStickyButtons)
            
        }
    }, [])

    useEffect(() => {
        if (!fetching && !session) {
            topNavTheme.setPublicMenuFlip(false)
            topNavTheme.setTheme(featuredArtwork.colourTheme === 'white' ? 'dark' : 'light')
        }
        
    }, [featuredArtwork])

    const artwork = featuredArtwork.featuredArtwork    

    let artworkImageUrl = null

    if (featuredArtwork.imageVariants) {
        artworkImageUrl = imageUrl(getImageByWidth(featuredArtwork.imageVariants, featuredArtwork.image))
    } else {
        if (artwork.mediaType === MediaType.Image) {
            if (featuredArtwork.imageVariants) {
                artworkImageUrl = imageUrl(getImageByWidth(featuredArtwork.imageVariants, featuredArtwork.image))
            } else
            if (artwork.imageVariants) {
                const variants = {...artwork.imageVariants, original: artwork.image}
                artworkImageUrl = imageUrl(getImageByWidth(variants, artwork.image))
            } else {
                imageUrl(artwork.image)
            }
        } else
        if (artwork.mediaType === MediaType.VideoLink) {
            artworkImageUrl = artwork.video.posterUrl
        }
    }

    const zineUrl = `${window.location.protocol}//${process.env.REACT_APP_HOST}/zine/${featuredArtwork.chapter}`
    const closeBtnElem = useRef(null)
    const expandBtnElem = useRef(null)
    const setStickyButtons = () => {
        if (featuredRef.current) {
            const containerBox = featuredRef.current.getBoundingClientRect();
            const topnavElem = document.getElementById('top-nav') || document.getElementById('public-menu')
            

            if (topnavElem && containerBox && closeBtnElem.current) {
                const expandInnerElem = document.getElementById('close-feature')
                const top = containerBox.top
                const bottom = top + (containerBox.height - expandInnerElem.offsetTop)
                
                if (top <= 0 && bottom >= topnavElem.clientHeight) {
                    closeBtnElem.current.style.transform = `translateY(${-1 * top}px)`;
                }  
            }

            if (topnavElem && containerBox && expandBtnElem.current) {
                const expandInnerElem = document.getElementById('expand-feature')
                const top = containerBox.top
                const bottom = top + (containerBox.height - expandInnerElem.offsetTop)
                
                if (top <= 0 && bottom >= topnavElem.clientHeight) {
                    expandBtnElem.current.style.transform = `translateY(${-1 * top}px)`;
                }  
            }
        }
    }

    const shareThemeMap = {
        'dark':"grey",
        'white':'black',
        'pink':'black'
    }

    return (
        <div ref={featuredRef} 
        style={{
            height: featuredArtworkSize
        }}
        className={"featured-space " + (open ? 'open' : '')}>
        {artwork !== null ?
            <>
            <div className="close-feature-div position-absolute">
                <CloseFeatureButton ref={closeBtnElem} src={f.closeIcon} addClass={f.class} passCloseSection={() => closeArtwork(true)} hide={!open} />
                <ExpandFeatureButton ref={expandBtnElem} src={f.expandIcon} addClass={f.class} passTriggerModal={triggerExpandModal} hide={!open} />
            </div>
            <div ref={coverRef} className="featured-cover">
                <img src={artworkImageUrl} className="featured-cover-img" alt="featured cover" />
                <div className={f.class + " sidebar"} onClick={openArtwork}>
                    <ArtworkAuthorDetails
                        user={artwork.user}
                        author={getName(artwork?.user).toLowerCase()}
                        authorStates={
                            {
                                normal: f.author,
                                hovered: f.mouseover.author
                            }
                        }
                        occupation={getOccupation(artwork?.user)}
                        occupationState={f.occupation}
                        location={countries.getName(artwork?.user?.countryCode, "en", { select: "official" })}
                    />

                    <div className="sidebar-inner">
                        <div className={"media-buttons media-sprite-20 d-flex justify-content-between align-items-center"}>
                            <Share url={zineUrl} size={20} theme={shareThemeMap[featuredArtwork.colourTheme]} />
                        </div>
                        <div ref={scrollableRef} className="sidebar-scrollable no-scroller overflow-y-auto text-left">
                            <div ref={scrollableInnerRef} className="sidebar-scrollable-inner">
                                <div className={f.title + " statement text-uppercase pn-bold mb-1"}>fashion statement</div>
                                {artwork.user?.fashionStatement ? <div className={f.text + " mb-5"}>{parse(artwork.user?.fashionStatement ?? '')}</div> : null}
                                <div className={f.title + " statement text-uppercase pn-bold mb-1"}>artwork title</div>
                                <Link style={{display:'block'}} className={f.text + " pb-5"} to={`/artworks/${artwork._id}`}>{artwork.title}</Link>
                                <div className={f.title + " statement text-uppercase pn-bold mb-1"}>artwork description</div>
                                <div className={f.text + " mb-5"}
                                    dangerouslySetInnerHTML={{__html: ensureLinks(artwork.description)}}
                                ></div>
                            </div>
                            <div className={"additional-author-content pb-4 w-100 left-0 " + (!hasScroll ? 'bottom-0' : '')}>
                                <Tags className={f.text} tags={artwork.tags} />
                                <AdditionalContent
                                    className={f.socialMedia}
                                    noMedia={windowWidth >= 1030 ? false : true}
                                    occupation=""
                                    profileLink={artwork.user.itchUrl}
                                    author={getName(artwork.user)}
                                    date={format(new Date(artwork.createdAt), 'MMMM d, yyyy')}
                                    states={{
                                        normal: f.socialMedia,
                                        hovered: f.mouseover.socialMedia
                                    }}
                                >
                                    at {format(new Date(artwork.createdAt), 'h:mm b')}
                                </AdditionalContent>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={f.class + " tint"} onClick={openArtwork}>
                <div className="featured-details middle-xy">
                    <div className="body-text pn-bold">
                        <img src={f.logo} className="artwork-logo" alt="logo" />
                        <div className={f.chapter + " chapter text-uppercase pink-text mt-3"}>zine chapter #{featuredArtwork.chapter}</div>
                        <div className={f.year + " year"}>{currentYear}</div>
                    </div>
                </div>
            </div>

            {open && artwork.mediaType === MediaType.VideoLink &&
                <figure className="play-button-div middle-xy">
                    <div onClick={triggerExpandModal}>
                        <button name="play"></button>
                    </div>
                </figure>
            }
            <ImagePopup ref={expandImageRef} img={artworkImageUrl} video={artwork.video} />
            </>: null }
        </div>
    )
}

export function ItchArticle({ itchArticle, defaultOpen = false }) {
    /*
    const { id, tint, title, author, occupation, cover, coverCaption, body, date, images, videoLinks, imageCaptions, tags, time } = articles[0];
    */
    

    const history = useHistory();
    const { windowWidth, isMobile } = useWindowDimensions();
    const { artworkIsClosed, itchArticleIsClosed, userArticleIsClosed, artworkAllowed, itchArticleAllowed, userArticleAllowed } = useArtworkArticleStatus();
    const maxHeight = 1332;
    let a = itchArticleTextColor[itchArticle.theme ?? 'pink'];
    let navHeight = useNavHeight();

    const [scrollAreaHeight, setScrollAreaHeight] = useState(0);
    const [open, setOpen] = useState(defaultOpen);

    const itchSpaceRef = useRef();
    const articleRef = useRef();
    const articleCoverRef = useRef();

    const shareUrl = `${window.location.protocol}//${process.env.REACT_APP_HOST}/itch-articles/${itchArticle?.slug}`

    const setConditionalHeight = () => {
        let height = null;
        if (defaultOpen) {
            if (articleCoverRef.current) {
                height = maxHeight - articleCoverRef.current.clientHeight;
            }
        }
        else {
            if (!isMobile) {
                if (open) {
                    height = scrollAreaHeight;
                }
                else height = 0;
            }
        }
        return height;
    }

    const openArticle = () => {
        if (!open) {
            // console.log('emit open article');
            Emitter.emit('openItchArticle');
        }
    }

    const waitForScroll = async () => {
        // scroll to article
        console.log('scrolling to article');
        const finishScrolling = await ScrollToArticle(itchSpaceRef, navHeight);
        // check if scroll is finished
        if (finishScrolling) {
            setOpen(true);
            setScrollAreaHeight(maxHeight - articleCoverRef.current.clientHeight);
            Emitter.emit('itchArticleIsOpened');
        }
    }

    const closeArticle = async (closeWithinArticle) => {
        if (open) {
            setScrollAreaHeight(0);
            // restart itch article scroller when closed
            articleRef.current.scrollTop = 0;
            setOpen(false);
            // console.log('waiting to close itch article');
            const finishClosing = await WaitForClose(articleCoverRef.current.clientHeight, itchSpaceRef);
            if (finishClosing) {
                console.log('emit itch is closed');
                Emitter.emit('itchArticleIsClosed');
                if (closeWithinArticle) Emitter.emit('closeWithin');
            }
        }
    }

    useEffect(() => {
        if (defaultOpen) setScrollAreaHeight(maxHeight - articleCoverRef.current.clientHeight);
        else {
            if (itchArticleAllowed) waitForScroll();
            else closeArticle();
        }
        // eslint-disable-next-line
    }, [itchArticleAllowed])

    // for debugging purpose, can be removed...
    useEffect(() => {
        /*
        console.log("artworkIsClosed:", artworkIsClosed);
        console.log("itchArticleIsClosed:", itchArticleIsClosed);
        console.log("userArticleIsClosed:", userArticleIsClosed);
        */
    }, [artworkIsClosed, itchArticleIsClosed, userArticleIsClosed])

    // for debugging purpose, can be removed...
    useEffect(() => {
        /*
        console.log('artworkallowed', artworkAllowed);
        console.log('itcharticleallowed', itchArticleAllowed);
        console.log('userarticleallowed', userArticleAllowed);
        */
    }, [artworkAllowed, itchArticleAllowed, userArticleAllowed])

    return (
        <>{itchArticle && itchArticle._id ?
        <div
            ref={itchSpaceRef}
            className={"article-space itch-space " + (open ? 'open' : '')}
            onClick={openArticle}
        >
            {!defaultOpen &&
                <div className="close-feature-div position-absolute">
                    <CloseFeatureButton
                        src={a.closeIcon}
                        addClass={a.class}
                        passCloseSection={() => closeArticle(true)}
                        hide={!open}
                    />
                </div>
            }
            <div ref={articleRef} className={a.class + " itch-article " + (isMobile ? 'overflow-y-auto no-scroller' : '')}>
                <div ref={articleCoverRef} className="article-cover-height">
                    <ItchArticleCover open={open} position={itchArticle?.coverImage.position ?? 'center center'} 
                        src={imageUrl(itchArticle?.coverImageVariants?.medium ?? itchArticle?.coverImage) ?? ''} />
                </div>
                <div className="before-tint" />
                <ItchArticleDetails 
                    open={false}
                    theme={itchArticle?.theme}
                    title={itchArticle?.title} 
                    subHead={itchArticle?.subHead}
                    category={itchArticle?.category}
                />
                <div className="scroll-area position-relative" style={{ height: setConditionalHeight() }}>
                    <div className="image-caption color-3c">{itchArticle.caption}</div>
                    <div className={"scroll-area-inner " + (windowWidth < 1030 && !isMobile ? 'no-scroller overflow-y-auto' : '')}>
                        <div className={"right-text-area text-left " + (windowWidth >= 1030 ? "position-absolute right-0" : "w-100 position-relative")}>
                            <ItchArticleDetails 
                                open={true} 
                                theme={itchArticle?.theme}
                                title={itchArticle?.title}
                                slug={itchArticle?.slug} 
                                subHead={itchArticle?.subHead}
                                category={itchArticle?.category}    
                            />
                            <AuthorSection className="author-section-share">
                                <AuthorInfoArticleDate>
                                    <div>
                                        By <b>Itch</b> 
                                        {itchArticle.itchArticleMentionUser ?
                                        <>
                                        &nbsp; / <AuthorLink to={`/${itchArticle.itchArticleMentionUser.itchUrl}`}>{getName({
                                        accountType: itchArticle.itchArticleMentionUser.accountType,
                                        firstName: itchArticle.itchArticleMentionUser.firstName,
                                        lastName: itchArticle.itchArticleMentionUser.lastName,
                                        companyName: itchArticle.itchArticleMentionUser.companyName
                                        })}</AuthorLink>
                                        <AuthorCategories>
                                        <AccountTypeCategories {...itchArticle.itchArticleMentionUser} />
                                        </AuthorCategories>
                                        </> : null }
                                    </div>
                                    <div>{format(new Date(itchArticle.createdAt), 'MMMM d yyyy')} at {format(new Date(itchArticle.createdAt), 'h:mma')}</div>
                                </AuthorInfoArticleDate>
                                <Sharing className="sharing-top">
                                    <Share url={shareUrl} theme="black" />
                                </Sharing>
                            </AuthorSection>
                            {!isMobile ? <ButtonToPastItchArticles to={'/archives/itch-articles'}>
                                <span className="icon">
                                    <img src={icons['line-arrow-right-black.svg']} alt=""/>
                                    <img src={icons['line-arrow-right-pink.svg']} alt=""/>
                                </span>
                                Previously on&nbsp;<b>itch</b>
                            </ButtonToPastItchArticles> : null}
                        </div>
                        <div className={"left-text-scroll text-left " + (windowWidth >= 1030 ? "position-absolute left-0 no-scroller overflow-y-auto" : "w-100 position-relative")}>
                            <div className="body-text" dangerouslySetInnerHTML={{__html: forceLinksBlankTarget(itchArticle.content)}} ></div>
                            <Tags tags={itchArticle.tags} />
                            <AdditionalContent
                                user
                                theme={itchArticle.theme ?? 'dark'}
                                shareUrl={shareUrl}
                                occupation={""}
                                profileLink={itchArticle.itchArticleMentionUser?.itchUrl}
                                author={getName(itchArticle.itchArticleMentionUser)}
                                date={format(new Date(itchArticle?.createdAt), 'MMMM d, yyyy')}
                                states={{
                                    normal: blackText,
                                    hovered: pinkText
                                }}
                            >
                                at {format(new Date(itchArticle?.createdAt), 'h:mm b')}
                            </AdditionalContent>
                            
                            <ButtonBottomToPastItchArticles>
                                <ButtonToPastItchArticles to={'/archives/itch-articles'}>
                                    <span className="icon">
                                        <img src={icons['line-arrow-right-black.svg']} alt=""/>
                                        <img src={icons['line-arrow-right-pink.svg']} alt=""/>
                                    </span>
                                    Previously on&nbsp;<b>itch</b>
                                </ButtonToPastItchArticles>
                            </ButtonBottomToPastItchArticles>
                            
                            <SignUpWidget/>

                            <Comment id={itchArticle._id} contentType={'articles'}  />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        : null}</>
    )
}

export function ItchArticleDetails({ 
    open, title, subHead, category, theme = 'pink', slug
  }) {
    // const { tint, type, title, description } = articles[0];
    let a = itchArticleTextColor[theme];
    const textColor = (color) => open ? 'pink-text' : color;
    return (
        <div className="article-details">
            {category ? <div className={textColor(a.type) + " text-uppercase pn-bold type"}>{category}</div> : null}
            <div className={textColor(a.type) + " body-text"}>
                {slug ? <Link className={textColor(a.title) + " nexa-x-bold title"} to={`/itch-articles/${slug}`}>{parse(title)}</Link> : 
                <div className={textColor(a.title) + " nexa-x-bold title"} >{parse(title)}</div>}
                <div className={textColor(a.description) + " desc"}>{subHead}</div>
            </div>
        </div>
    )
}

export function UserArticleGridContainer({
    items
}) {
    const { userArticleAllowed } = useArtworkArticleStatus();
    const { windowWidth, isMobile } = useWindowDimensions();
    const [requestedElement, setRequestedElement] = useState(null);
    const [allowedElement, setAllowedElement] = useState(null);
    const [openedElement, setOpenedElement] = useState(null);
    const [initialHeight, setInitialHeight] = useState(0);

    const handleOpenRequest = (index) => {
        // console.log('emit open user article');
        // disallow all user articles when new request is being handled
        setAllowedElement(null);
        setRequestedElement(index);
        Emitter.emit('openUserArticle');
    }
    const handleOpenedUserArticle = (index) => {
        setOpenedElement(index);
    }

    // clear opened user article
    const clearElement = () => {
        // make sure to disallow and close opened article
        setAllowedElement(null);
        setOpenedElement(null);
    }

    useEffect(() => {
        if (isMobile) setInitialHeight(windowWidth);
        else setInitialHeight(windowWidth / 5 * 2);
        // eslint-disable-next-line
    }, [windowWidth])

    useEffect(() => {
        // allow an article to open when general state is allowed
        if (userArticleAllowed) setAllowedElement(requestedElement);
        else setAllowedElement(null);
    }, [requestedElement, userArticleAllowed])

    const chunks = chunk(items, 4)

    return (
        <div className="user-article-grid-container position-relative">
            {chunks.map((part, p) => (
            <div key={p} className={`grid article-space ${ p % 2 === 0 ? 'even' : 'odd'}`}>
                {part.map((item, i) => (
                <>
                {item.type === 'user' ? <Mention user={item.user} /> : null}
                {item.type === 'article' ? 
                <UserArticle
                    article={item.article}
                    index={`${i}`}
                    initialHeight={initialHeight}
                    requestToOpen={() => handleOpenRequest(`${i}`)}
                    setElement={() => handleOpenedUserArticle(`${i}`)}
                    clearElement={clearElement}
                    allowed={allowedElement === `${i}`}
                    open={openedElement === `${i}`}
                /> : null}
                </>
                ))}
            </div>
            ))}
        </div>
    )
}

export function UserArticle({ 
    article, index, initialHeight, requestToOpen, setElement, clearElement, allowed, open 
}) {
    const { 
        _id,
        title,
        subHead,
        coverImage,
        theme,
        user,
    } = article;
    const articleRef = useRef();
    const history = useHistory();
    let a = userArticleTextColor[theme];
    let navHeight = useNavHeight();

    const openArticle = () => {
        // only request to open when an article is closed
        if (!open) requestToOpen();
    }

    const waitForScroll = async () => {
        if (!open) {
            console.log('user waiting for scroll');
            // scroll to article
            const finishScrolling = await ScrollToArticle(articleRef, navHeight);
            // check if scroll is finished
            if (finishScrolling) {
                // set opened article
                setElement();
                // temporary
                const titleInUrl = getUniqueUrl(title);
                history.push({
                    pathname: `/${titleInUrl}-${_id}`,
                    state: {
                        article: 'user',
                        index: index + 1 // skip first article which is itch article
                    }
                });
            }
        }
    }

    const closeArticle = async (closeWithinArticle) => {
        if (open) {
            // close opened article
            clearElement();
            console.log('waiting to close user article');
            const finishClosing = await WaitForClose(initialHeight, articleRef);
            if (finishClosing) {
                console.log('emit user is closed');
                Emitter.emit('userArticleIsClosed');
                if (closeWithinArticle) Emitter.emit('closeWithin');
            }
        }
    }

    useEffect(() => {
        // scroll when allowed, close when disallowed
        if (allowed) waitForScroll();
        else closeArticle();
        // eslint-disable-next-line
    }, [open, initialHeight, allowed])

    return (
        <div
            ref={articleRef}
            className={"article-container user-article position-relative " + (open ? 'open' : '')}
            onClick={openArticle}
            style={{ border: open ? '2px solid red' : 0 }} // temporary
        >
            <ArticleCover src={imageUrl(coverImage) ??''} position={coverImage.position} />
            <div className={a.class + " tint"}>
                <div className="article-details">
                    {user ? <AvatarWrapper user={user} /> : null}
                    <div className="body-text pn-bold">
                        <div className={a.description + " title"}>{title}</div>
                        <div className={a.description + " subtitle pn"}>{subHead}</div>
                        {user ? <div className={a.description + " desc"}>
                            <span className="pn">By </span>{getName(user)}, {getOccupation(user)}
                        </div> : null}
                    </div>
                </div>
            </div>
        </div>
    )
}

export function MentionOld({user}) {
    const {
        _id,
        accountType,
        profileImage,
        countryCode,
        colourTheme
    } = user
    const { windowWidth } = useWindowDimensions();
    return (
        <div className="mention-container position-relative">
            <ArticleCover src={imageUrl(profileImage) ?? getAccountTypeMeta(accountType).fallBackAvatar} position={profileImage.position} />
            <div className="tint tint1">
                <div className="article-details pn-bold">
                    <div className="body-text">
                        <img src={Trending} alt="trending icon" />
                        <div className="text-uppercase trending">trending</div>
                        <div className="author overflow-hidden text-overflow-ellipsis line-clamp-2">{getName(user)}</div>
                        <div className={"occupation overflow-hidden text-overflow-ellipsis " + (windowWidth > 1030 ? 'line-clamp-2' : 'line-clamp-3' )}>{getOccupation(user)}</div>
                    </div>
                </div>
            </div>
            <div className={colourTheme + "-tint tint tint2 d-flex flex-column"}>
                <div className="author-details-wrapper position-relative">
                    <div className={"author-details-inner d-flex " + (windowWidth > 1030 ? '' : 'middle-y w-100')} >
                        <div className={"sprites sprite-" + getAccountTypeAbbr(accountType)} />
                        <div className="author-details flex-grow-1 overflow-hidden text-left">
                            <div className="author overflow-hidden text-overflow-ellipsis line-clamp-2 pn-bold">{getName(user)}</div>
                            <div className={"occupation overflow-hidden text-overflow-ellipsis " + (windowWidth > 1030 ? 'line-clamp-2' : 'line-clamp-3' )}>{getOccupation(user)}</div>
                            <LocationIconWrapper textColor='' location={countries.getName(countryCode, "en", { select: "official" })} />
                        </div>
                    </div>
                </div>
                <div className="line" />
                <div className={"statement overflow-hidden text-overflow-ellipsis text-left " + (windowWidth > 1030 ? 'line-clamp-5' : 'line-clamp-3' )}>{}</div>
                <div className="view-profile-wrapper flex-grow-1 d-flex justify-content-end align-items-end">
                    <div className="view-profile-inner d-inline-flex align-items-center">
                        <a href={`/user/${_id}`} className="view-profile url-underline d-inline pn-bold">View profile</a>
                        <div className="sprites eye-icon d-inline" alt="eye-icon" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export function ArticleCover({ src, position}) {
    return (
        <div className="article-cover">
            <img src={src} style={{
                objectFit: 'cover',
                objectPosition: position ?? 'center center'
            }} alt="article cover" />
        </div>
    )
}

export function AvatarWrapper({ user }) {
    return (
        <div className="avatar-wrapper">
            <UserAvatar {...user} alt='' />
        </div>
    )
}

export function SocialMedia({ link, type, states }) {
    const [hovered, setHovered] = useState(false);
    return (
        // <Link>
        <a
            href={link}
            onMouseOver={() => setHovered(true)}
            onMouseOut={() => setHovered(false)}
        >
            <div className={type + " sprites " + (hovered ? states.hovered : states.normal)}></div>
        </a>
    )
}

/*
export function ImageWithCaption({ src, link, caption, position = 'center center' }) {
    const expandImageRef = useRef();
    const playVideo = () => expandImageRef.current.triggerModal();
    return (
        <div className="image-with-caption-div">
            <ArticleCover src={src} position={position} />
            {link &&
                <figure className="play-button-div middle-xy">
                    <div onClick={playVideo}>
                        <button name="play"></button>
                    </div>
                </figure>
            }
            <div className="image-caption color-3c">{parse(caption)}</div>
            <ImagePopup ref={expandImageRef} video={link} />
        </div>
    )
}
*/

export function Tags({ className, tags }) {
    const [display, setDisplay] = useState(false);
    const loggedIn = !!useUserStatus();
    const history = useHistory();
    const handleClick = () => {
        if (loggedIn) {
            setDisplay(false);
            return false;
            // history.push('/#'); // url to be changed... or it can be a prop
        }
        else setDisplay(true);
    }

    const toggleDisplay = () => setDisplay(false); // make sure JoinUsModal displays every time tag is clicked

    return (
        <>
            {display && <JoinUsModal timeout={0} continuousToggling={true} passToggle={toggleDisplay} /> /* timeout zero to display immediately */}
            <div className={"tags-div " + (className ? className : '')}>
                {tags.map((val, i) =>
                    <div key={i} onClick={handleClick} className="tag d-inline-block">{val}</div>
                )}
            </div>
        </>
    )
}

export function AdditionalContent({ 
    className, noMedia = false, occupation, 
    profileLink, author, date, states, 
    itch = true, children, shareUrl, theme
}) {
    const { normal, hovered } = states;

    const themeMaps = {
        'dark': 'black',
        'white': 'black',
        'pink': 'black'
    }
    
    return (
        <div className={"additional-content pn-bold position-relative " + (className ? className : '')}>
            <div className="info-div d-inline-block">
                <div className="info-1">
                    {itch ?
                        <>
                            <span className="pn">By </span>{occupation && occupation + " /"} <a href={profileLink} className="url-underline">{author}</a>,
                        </>
                        :
                        <>
                            <span className="pn">By </span><a href={profileLink} className="url-underline">{author}</a>
                            <span className="pn">, {occupation},</span>
                        </>
                    }
                </div>
                <div className="info-2">
                    <span className="pn">{date} {children}</span>
                </div>
            </div>
            {!noMedia &&
                <div className="media-buttons media-sprite-16 d-inline-flex justify-content-between">
                    <Facebook className="share-btn" theme={themeMaps[theme]} url={shareUrl} />
                    <Twitter className="share-btn" theme={themeMaps[theme]} url={shareUrl} />
                    <Pinterest className="share-btn" theme={themeMaps[theme]} url={shareUrl} />
                    <CopyLink className="share-btn" theme={themeMaps[theme]} url={shareUrl} />
                </div>
            }
        </div>
    )
}

export function LogoAnimation({ handleClickArchive }) {
    const initialEndContentHeight = 350;
    const { windowWidth, windowHeight } = useWindowDimensions();
    const [endContentHeight, setEndContentHeight] = useState(initialEndContentHeight);
    const [startAnimation, setStartAnimation] = useState(false);

    const squareRef = useRef();
    const triggerRef = useRef();

    const handleEnter = (e) => {
        setImmediate(() => {
            console.log('handle enter')
            if (e.type === 'enter') {
                setStartAnimation(true);
            }
            if (e.scrollDirection === 'REVERSE' && e.type === 'leave') {
                setStartAnimation(false);
            }
        })
    }

    useEffect(() => {
        if (startAnimation) {
            let square = squareRef.current.getBoundingClientRect();
            if (square.bottom > (windowHeight - initialEndContentHeight)) {
                let diff = square.bottom - (windowHeight - initialEndContentHeight) + 20;
                setEndContentHeight(initialEndContentHeight - diff);
            }
        }
        // eslint-disable-next-line
    }, [windowHeight, startAnimation])

    return (
        <>
            <div ref={triggerRef} id="trigger" style={{ height: windowHeight + endContentHeight }}></div>
            <Controller>
                <Scene
                    triggerElement="#trigger"
                    triggerHook={1}
                    duration="100%"
                // indicators={true}
                >
                    {/* background opacity control */}
                    {progress => (
                        <Tween
                            totalProgress={progress}
                            paused
                            from={{ background: 'rgba(36, 36, 36, 0.2)' }}
                            to={{ background: 'rgba(36, 36, 36, 0.9)' }}
                        >
                            <div className={"logo-animation " + (startAnimation ? 'd-block' : 'd-none')}>
                                <div ref={squareRef} className="virtual-square middle-x">
                                    <Scene
                                        triggerElement="#trigger"
                                        triggerHook={1}
                                        duration="100%"
                                    // indicators={true}
                                    >
                                        {/* logo animation control */}
                                        {(progress, event) => {
                                            handleEnter(event);
                                            return (
                                                <Timeline
                                                    totalProgress={progress >= 0.9 ? 1 : progress} // make sure logo forms into complete form after coming from 4 corners
                                                    paused
                                                    target={
                                                        <>
                                                            <div className="part top top-left"></div>
                                                            <div className="part bottom bottom-right"></div>
                                                            <div className="part right right-top"></div>
                                                            <div className="part left left-bottom"></div>
                                                            <div className="part right right-bottom"></div>
                                                            <div className="part left left-top"></div>
                                                            <div className="part bottom bottom-left"></div>
                                                            <div className="part top top-right"></div>
                                                        </>
                                                    }
                                                >
                                                    <Tween target={0} from={{ top: windowHeight }} to={{ top: 0 }} position={0} duration={2} />
                                                    <Tween target={1} from={{ bottom: windowHeight }} to={{ bottom: 0 }} position={0} duration={2} />
                                                    <Tween target={2} from={{ right: windowWidth }} to={{ right: '15%' }} position={2} duration={3} />
                                                    <Tween target={3} from={{ left: windowWidth }} to={{ left: '15%' }} position={2} duration={3} />
                                                    <Tween target={4} from={{ right: windowWidth }} to={{ right: '15%' }} position={4.5} duration={3} />
                                                    <Tween target={5} from={{ left: windowWidth }} to={{ left: '15%' }} position={4.5} duration={3} />
                                                    <Tween target={6} from={{ bottom: windowHeight }} to={{ bottom: 0 }} position={5} duration={2.5} />
                                                    <Tween target={7} from={{ top: windowHeight }} to={{ top: 0 }} position={5} duration={2.5} />
                                                </Timeline>
                                            )
                                        }}
                                    </Scene>
                                </div>
                                <Scene
                                    triggerElement="#trigger"
                                    triggerHook={1}
                                    offset={(0.4 * windowHeight)}
                                    duration="100%"
                                // indicators={true}
                                >
                                    {/* end content control */}
                                    {progress => (
                                        <Tween
                                            totalProgress={progress}
                                            paused
                                            from={{ bottom: -windowHeight }}
                                            to={{ bottom: 0 }}
                                        >
                                            <div className="movable-end-content" style={{ height: endContentHeight }}>
                                                <div className="title">Let’s fashion the future, in human fashion.</div>
                                                <div className="pink-text"><Link to="/signup" className="pn-bold">Sign up</Link> to fashion a revolution!</div>
                                                <div className="view-archive-div">
                                                    <div className="view-archive-button text-uppercase pn-bold" onClick={handleClickArchive}>view archive</div>
                                                </div>
                                                <Footer displayAll={true} />
                                            </div>
                                        </Tween>
                                    )}
                                </Scene>
                            </div>
                        </Tween>
                    )}
                </Scene>
            </Controller>
        </>
    )
}

export const ChangeableNavigation = forwardRef(({ activeTab, addClasses, scrollY, openState }, ref) => {
    const [change, setChange] = useState(false);
    useImperativeHandle(ref, () => ({
        changeNav() {
            setChange(true);
        },
        checkScrollPosition() {
            if (window.scrollY > scrollY) setChange(true);
            else setChange(false);
        }
    }))

    const handleScroll = () => {
        if (window.scrollY > scrollY) setChange(true);
        else {
            if (!openState) setChange(false);
        }
    };
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
        // eslint-disable-next-line
    }, [openState])
    return (
        <>
            <Navigation activeTab={activeTab} displayAll={true} addClass={`${addClasses.home2} ${change ? 'leave' : 'enter'}`} noLogo={true} />
            <Navigation activeTab={activeTab} displayAll={true} addClass={`${addClasses.home1} ${change ? 'enter' : 'leave'}`} />
        </>
    )
})
/*
export function forwardRef(CloseFeatureButton({ src, addClass, passCloseSection, hide }) {
    return (
        <div
            className={"close-feature d-flex justify-content-center align-items-center " + (addClass ? addClass : "")}
            onClick={passCloseSection}
            style={{ visibility: hide ? 'hidden' : 'visible' }}
        >
            <img src={src} className="align-self-center" alt="" />
        </div>
    )
})

export function ExpandFeatureButton({ src, addClass, passTriggerModal, hide }) {
    return (
        <div
            className={"expand-feature d-flex justify-content-center align-items-center " + (addClass ? addClass : "")}
            onClick={() => passTriggerModal()}
            style={{ visibility: hide ? 'hidden' : 'visible' }}
        >
            <img src={src} className="align-self-center" alt="" />
        </div>
    )
}
*/

export const ImagePopup = forwardRef(({ img, video }, ref) => {
    const { windowWidth } = useWindowDimensions();
    const [showModal, toggleModal] = useReducer(
        showModal => !showModal,
        false
    );

    useImperativeHandle(ref, () => ({
        triggerModal() {
            toggleModal()
        }
    }))

    return (
        <Modal
            id="imagePopup"
            backdropClassName="fa-modal-backdrop"
            dialogClassName="fa-modal-dialog"
            contentClassName="fa-modal-content"
            show={showModal}
            onHide={toggleModal}
            animation={false}>
            <CloseButton closeModal={toggleModal} passOpacity={(opacity) => null} />
            {video ?
                <ReactPlayer
                    className='popup-player middle-xy'
                    url={video.url}
                    controls={true}
                    playing={true}
                    width={windowWidth >= 1030 ? "60%" : "100%"}
                    height="50vh"
                />
                :
                <img src={img} className="expanded-artwork" alt="featured artwork" />
            }
        </Modal>
    )
})

export const ArchiveModal = forwardRef((props, ref) => {
    const { windowHeight, isMobile } = useWindowDimensions();
    const { 
        artworks, loading, success, 
        hasNextPage: archivedHasNextPage, 
        nextPage: getNextArchivedPage ,
        getArchives,
        totalItems
    } = useGetArchivedFeaturedArtworks({
        enabeld: true,
        size: isMobile ? 10 : 30
    })
    const [showModal, toggleModal] = useReducer(
        showModal => !showModal,
        false
    );
    const horizontalScrollLast = useRef(null)
    const bigImageSliderRef = useRef();
    const mobileHorizontalScrollRef = useRef(null)
    const lastY = useRef(0);
    const [index, setIndex] = useState(0);
    const [touchX, setTouchX] = useState(0);
    const [touchY, setTouchY] = useState(0);
    const [translateY, setTranslateY] = useState(0);

    useImperativeHandle(ref, () => ({
        triggerModal() {
            toggleModal();
        }
    }))

    let offsetTop = useNavHeight();
    let verticalSliderHeight = isMobile ? 113 : 0;

    const goPrev = () => setIndex(index - 1);
    const goNext = () => setIndex(index + 1);

    useEffect(() => {
        if (success && index >= artworks.length && archivedHasNextPage) {
            getNextArchivedPage()
        }
    }, [index, artworks, archivedHasNextPage, getNextArchivedPage])

    const handleWheel = (scroll) => {
        setTimeout(() => {
            // scrolling up
            if (scroll < 0) {
                if (index > 0) goPrev();
            }
            // scrolling down
            else if (scroll > 0) {
                if (index < totalItems - 1) goNext();
            }
        }, 500);
    };

    const onWheel = (event) => {
        setTimeout(() => {
            // scrolling up
            if (event.deltaY < 0) {
                if (index > 0) goPrev();
            }
            // scrolling down
            else if (event.deltaY > 0) {
                if (index < totalItems - 1) goNext();
            }
        }, 500);
    }

    const handleTouchStart = (e) => {
        setTouchX(e.touches[0].clientX);
        setTouchY(e.touches[0].clientY);
    }

    const handleTouchMove = (e) => {
        let lastTouch = e.changedTouches[0];
        let xDiff = touchX - lastTouch.clientX;
        let yDiff = touchY - lastTouch.clientY;
        // if significant swipe is up down
        if (Math.abs(yDiff) > Math.abs(xDiff)) handleWheel(yDiff);
    };

    const verticalChange = () => {
        if (bigImageSliderRef.current) {
            let verticalChange = 0;

            for (var i = 0; i < artworks.length; i++) {
                let imageHeight = bigImageSliderRef.current.children[i].clientHeight;
                
                if (i < index) {
                    verticalChange += imageHeight;
                }
                else if (i === index) {
                    // console.log('halfed', i, index)
                    verticalChange += imageHeight / 2;
                }

                // console.log(index, i, verticalChange);
                
                if (i === artworks.length - 1) {
                    // console.log(index, i, artworks.length, windowHeight, offsetTop, verticalSliderHeight, imageHeight, verticalChange)
                    setTranslateY((windowHeight - offsetTop - verticalSliderHeight) / 2 - verticalChange);
                }
            }
        }
    }

    // readjust vertical slider on index change
    useEffect(() => {
        if (showModal) {
            verticalChange();
            document.body.classList.add('no-scroll')
        } else {
            document.body.classList.remove('no-scroll')
        }
        // eslint-disable-next-line
    }, [index, showModal])
    
    useEffect(() => {
        if (props.show) {
            toggleModal()
        }
    }, [props])

    const getArtworkCoverSmall = ({
        imageVariants,
        featuredArtwork
    }) => {
        return imageUrl(featuredArtwork?.imageVariants?.small ?? featuredArtwork.image)
    }

    const getArtworkCoverThumb = ({
        imageVariants,
        featuredArtwork
    }) => {
        if (imageVariants) {
            return imageUrl(imageVariants.thumb)
        }
        if (featuredArtwork.mediaType === MediaType.Image) {
            if (isMobile)
                return imageUrl(featuredArtwork?.imageVariants?.thumb2 ?? featuredArtwork.image)
            else
                return imageUrl(featuredArtwork?.imageVariants?.small ?? featuredArtwork.image)
        } else {
            return featuredArtwork.video.posterUrl
        }
    }

    const getArtworkCoverLarge = ({
        imageVariants,
        featuredArtwork
    }) => {
        if (imageVariants) {
            return imageUrl(getImageByWidth(
                imageVariants,
                featuredArtwork.image,
                isMobile ? 0.6 * window.innerWidth : (window.innerWidth - 170)/2
            ))
        }
        if (featuredArtwork.mediaType === MediaType.Image) {
            if (isMobile) {
                return imageUrl(featuredArtwork?.imageVariants?.small2 ?? featuredArtwork.image)
            } else {
                return imageUrl(featuredArtwork?.imageVariants?.medium ?? featuredArtwork.image)
            }
        } else {
            return featuredArtwork.video.posterUrl
        }
    }

    const getArtworkCoverProps = ({
        imageVariants,
        featuredArtwork
    }) => {
        const widthPx = isMobile ? 0.6 * window.innerWidth : (window.innerWidth - 170)/2
        if (featuredArtwork.mediaType === MediaType.Image) {
            const ratio = widthPx / featuredArtwork?.imageVariants?.medium.width
            return {
                width: `${widthPx}px`,
                height: `${ratio * featuredArtwork?.imageVariants?.medium.height}px`
            }
        } else {
            return {
                width:'auto',
                height:'auto'
            }
        }
    }
    
    const bottomScrollRef = useBottomScrollListener(() => {
        if (archivedHasNextPage) {
            getNextArchivedPage()
        }
    });

    useEffect(() => {
        if (artworks && success && isMobile && mobileHorizontalScrollRef && mobileHorizontalScrollRef.current && getNextArchivedPage) {
            // console.log('setup mobile horizontal scroll end')
            mobileHorizontalScrollRef.current.addEventListener('scroll', (evt) => {
                // console.log('setup mobile horizontal scroll end', evt)
                if ((mobileHorizontalScrollRef.current.scrollLeft + 150) >= (mobileHorizontalScrollRef.current.scrollWidth - mobileHorizontalScrollRef.current.clientWidth)) {
                    // Horizontal scroll has reached the end
                    clearTimeout(horizontalScrollLast.current)
                    horizontalScrollLast.current = setTimeout(() => {  
                        getNextArchivedPage()
                    }, 200)
                }
            })
        }
    }, [artworks, success, isMobile, mobileHorizontalScrollRef, getNextArchivedPage])

    const onImageLoaded = (index) => {
        // first image load to adjust position
        verticalChange();
    }

    useEffect(() => {
        verticalChange();
    }, [windowHeight])
    
    useEffect(() => {
        return () => {
            document.body.classList.remove('no-scroll')
            window.scrollTo(0,0)
        }
    }, [])

    return (
        <Modal
            id="archiveModal"
            className={`archive-modal minus-${offsetTop}`}
            backdropClassName={`archive-modal-backdrop minus-${offsetTop}`}
            dialogClassName=""
            contentClassName=""
            animation={true}
            show={showModal}
            onHide={toggleModal}
        >
            <Modal.Body className="vertical-slider-wrapper p-0 overflow-hidden">
                {success ? <>
                    <div className={"vertical-slider-inner d-flex " + (!isMobile ? 'h-100' : '')}>
                        <div
                            ref={bigImageSliderRef}
                            className="big-image-slider position-relative"
                            onWheel={onWheel/*(e) => handleWheel(e.deltaY)*/}
                            onTouchStart={handleTouchStart}
                            onTouchMove={handleTouchMove}
                            style={{ transform: `translateY(${translateY}px)` }}
                        >
                            {artworks.map((val, i) =>
                                <div key={i} style={getArtworkCoverProps(val)} className={"slide-item " + (index === i ? 'active' : '')}>
                                    <img onLoad={() => {
                                        onImageLoaded(i)
                                    }} 
                                        loading={`${index === i ? 'eager':'lazy'}`}
                                        src={getArtworkCoverLarge(val)} 
                                        className="w-100" alt="article cover" />
                                </div>
                            )}
                        </div>
                        <div
                            className="vertical-slider-controller position-relative"
                            onWheel={onWheel}
                            onTouchStart={handleTouchStart}
                            onTouchMove={handleTouchMove}
                        >
                            <div className="vertical-slider-info h-100">
                                {artworks.map(({ featuredArtwork, chapter}, i) =>
                                    <div
                                        key={i}
                                        className={"slide-item position-absolute overflow-hidden h-100 w-100 " + (index === i ? 'active' : '')}
                                        style={{ transform: `translateY(${100 * (i - index)}%)` }}
                                    >
                                        <div className="full-details middle-xy text-center">
                                            <ArtworkAuthorDetails 
                                                user={featuredArtwork?.user}
                                                author={getName(featuredArtwork?.user)}
                                                authorStates={
                                                    {
                                                        normal: whiteText,
                                                        hovered: pinkText
                                                    }
                                                }
                                                occupation={getOccupation(featuredArtwork?.user)}
                                                occupationState={whiteText}
                                                location={countries.getName(featuredArtwork?.user?.countryCode, "en", {select: "official"})}/>
                                            <a
                                                className="chapter white-text text-uppercase text-decoration-underline pn-bold mt-4"
                                                href={`/zine/${chapter}`}
                                            >
                                                view zine chapter #{chapter}
                                            </a>
                                        </div>
                                    </div>
                                )}
                            </div>
                            {index > 0 && <div className="arrow-prev middle-x" onClick={goPrev} />}
                            {index < artworks.length - 1 && <div className="arrow-next middle-x" onClick={goNext} />}
                            <CloseButton addClass="h-auto position-absolute" closeModal={toggleModal} passOpacity={(opacity) => null} />
                        </div>
                        {!isMobile &&
                            <div className="vertical-slider position-relative no-scroller overflow-y-auto" ref={bottomScrollRef}>
                                {artworks.map((val, i) =>
                                    <div key={i} onClick={() => setIndex(i)}>
                                        <ArticleCover src={getArtworkCoverThumb(val)} />
                                    </div>
                                )}
                            </div>
                        }
                    </div>
                    {isMobile &&
                        <div className="vertical-slider d-flex w-100 no-scroller overflow-x-auto" ref={mobileHorizontalScrollRef}>
                            {artworks.map((val, i) =>
                                //style={{ opacity: i === index-1 || i === index+1 ? 0.2 : 1 }}
                                <div key={i} className="d-inline-block" onClick={() => setIndex(i)}>
                                    <ArticleCover src={getArtworkCoverThumb(val)} />
                                </div>
                            )}
                        </div>
                    }
                </> : null}
                {loading ? <ProgressLoader/> : null}
            </Modal.Body>
        </Modal>
    )
})

// functions

export function useNavHeight() {
    // const loggedIn = !!useUserStatus();
    const { windowWidth } = useWindowDimensions();
    let navHeight = 0;
    if (windowWidth <= 1030) {
        navHeight = 45;
    }
    else {
        navHeight = 65;
    }
    return navHeight;
}

export function getUniqueUrl(title) {
    return title.replaceAll('<br/>', '').replaceAll(' ', '-');
}

// **for future use**
// export function AdSpace({ height }) {
//     return (
//         <Controller>
//             <Scene
//                 triggerElement=".ad-space"
//                 triggerHook={0}
//                 pinSettings={{ pushFollowers: false }}
//                 duration={height}
//             // indicators={true}
//             >
//                 <div className="ad-space">
//                     <div className="d-flex justify-content-center align-items-center">
//                         AD SPACE
//                     </div>
//                 </div>
//             </Scene>
//         </Controller>
//     )
// }